import {
  type PropsWithChildren,
  useCallback,
  useLayoutEffect,
  useRef,
} from 'react';

import { ScrollArea } from '@components/ui/scroll-area';
import { useHeader } from '@contexts/header';
import { cn } from '@lib/ui/cn';
import { useLocation } from 'react-router';

import { ScrollContext } from './context';

export const ScrollProvider = ({ children }: PropsWithChildren) => {
  const { pathname } = useLocation();
  const { hasBanner } = useHeader();

  const ref = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    ref.current?.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, [pathname]);

  const handleScrollTo = useCallback((top = 0) => {
    ref.current?.scrollTo({ top, left: 0, behavior: 'smooth' });
  }, []);

  return (
    <ScrollContext.Provider
      value={{
        onScrollTo: handleScrollTo,
      }}>
      <ScrollArea
        className={cn(
          'w-full',
          hasBanner
            ? 'mt-[140px] h-[calc(100svh-140px)]'
            : 'mt-[70px] h-[calc(100svh-70px)]',
          (pathname.includes('/topicos') ||
            pathname.startsWith('/medicamentos/')) &&
            hasBanner &&
            'mt-[195px] h-[calc(100svh-195px)]',
          (pathname.includes('/topicos') ||
            pathname.startsWith('/medicamentos/')) &&
            !hasBanner &&
            'mt-[125px] h-[calc(100svh-125px)]',
        )}
        id="main-scroll"
        refViewport={ref}>
        {children}
      </ScrollArea>
    </ScrollContext.Provider>
  );
};
